// extracted by mini-css-extract-plugin
module.exports =  {"alert":"iPtloAqeb19ZAFJRGz8X"};